export const environment = {
  production: false,
  apiUrl: 'https://admin-api.aeonmalllogiplus.com.kh',
  googleMapKey: 'AIzaSyCpVhQiwAllg1RAFaxMWSpQruuGARy0Y1k'
};
